<script setup>
const { item } = defineProps({
  item: Object,
})

const scoreA = computed(() => item.enrichment?.players?.find((player) => player.name === 'mattie')?.score)
const scoreB = computed(() => item.enrichment?.players?.find((player) => player.name === 'marieke')?.score)
</script>

<template>
  <div class="size-full relative font-cervo text-white">
    <div class="absolute right-0 inset-y-0 w-1/2 pt-[410px] pl-60 space-y-8">
      <div class="flex items-center gap-32 mb-6">
        <div class="text-[600px] font-bold leading-none w-64 text-center">{{ scoreA }}</div>
        <div class="flex flex-col">
          <div class="text-[100px]">{{ scoreA }} / 10 Vlaggen</div>
          <div class="text-[410px] font-bold leading-none -mt-6 -tracking-[0.03em]">Mattie</div>
        </div>
      </div>
      <div class="flex items-center gap-32 mb-6">
        <div class="text-[600px] font-bold leading-none w-64 text-center">{{ scoreB }}</div>
        <div class="flex flex-col">
          <div class="text-[100px]">{{ scoreB }} / 10 Vlaggen</div>
          <div class="text-[410px] font-bold leading-none -mt-6 -tracking-[0.03em]">Marieke</div>
        </div>
      </div>
    </div>
  </div>
</template>
